import { SHARD_UNLOCKS } from '../data/shardUnlocks.js';
import { audio } from '../systems/audio/AudioSystem.js';

/** Shop page: spends Shards on one-time perks, via SaveManager. */
export class ShopShardsMenu {
  constructor(root, save, { onBack }) {
    this.root = root;
    this.save = save;
    this.onBack = onBack;
    this.el = document.createElement('div');
    this.el.className = 'menu-overlay shop-detail-overlay';
    this._render();
    this.root.appendChild(this.el);
  }

  _render() {
    // See ShopEchoMenu._render for why the scroll position needs saving
    // across a re-render.
    const rowsEl = this.el.querySelector('.shop-rows');
    const scrollPosition = rowsEl?.scrollTop ?? 0;
    this.el.innerHTML = '';

    const title = document.createElement('div');
    title.className = 'menu-title';
    title.textContent = 'SHARD PERKS';
    this.el.appendChild(title);
    const label = document.createElement('div');
    label.className = 'menu-kicker';
    label.textContent = 'SOVEREIGN UNLOCKS';
    this.el.insertBefore(label, title);

    const shards = document.createElement('div');
    shards.className = 'menu-echoes';
    shards.innerHTML = `Shards: <span class="menu-shards-value">${this.save.shards}</span>`;
    this.el.appendChild(shards);

    const rows = document.createElement('div');
    rows.className = 'shop-rows';
    for (const def of Object.values(SHARD_UNLOCKS)) {
      rows.appendChild(this._buildPerkRow(def));
    }
    this.el.appendChild(rows);
    const hint = document.createElement('div');
    hint.className = 'scroll-hint';
    hint.textContent = '▼ Scroll to browse';
    this.el.appendChild(hint);

    const back = document.createElement('button');
    back.type = 'button';
    back.className = 'menu-button';
    back.textContent = 'Back';
    back.addEventListener('click', () => { audio.playSfx('click'); this.onBack(); });
    this.el.appendChild(back);

    rows.scrollTop = scrollPosition;
  }

  _buildPerkRow(def) {
    const owned = this.save.isPerkUnlocked(def.id);
    const canAfford = !owned && this.save.shards >= def.cost;

    const row = document.createElement('div');
    row.className = 'shop-row';

    const info = document.createElement('div');
    info.className = 'shop-row-info';
    info.innerHTML = `
      <div><span class="shop-row-name">${def.name}</span></div>
      <div class="shop-row-desc">${def.description}</div>
    `;
    row.appendChild(info);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'menu-button menu-button-small';
    button.textContent = owned ? 'Owned' : `Buy — ${def.cost}`;
    button.disabled = owned || !canAfford;
    button.addEventListener('click', () => {
      if (this.save.spendShards(def.cost)) {
        this.save.unlockPerk(def.id);
        audio.playSfx('levelup');
        this._render();
      }
    });
    row.appendChild(button);

    return row;
  }

  destroy() {
    this.el.remove();
  }
}
